import React from "react";

const Bullet = ({ className }) => (
  <span className={`inline-block h-3 w-3 rounded ${className}`} />
);

const Legend = () => (
  <div className="inline-flex items-center gap-4 text-xs text-slate-700 dark:text-slate-300">
    <span className="inline-flex items-center gap-2">
      <Bullet className="bg-emerald-500/90" /> Présent
    </span>
    <span className="inline-flex items-center gap-2">
      <Bullet className="bg-rose-500/90" /> Absent
    </span>
    <span className="inline-flex items-center gap-2">
      <Bullet className="bg-slate-200/60 dark:bg-slate-800/60" /> Non saisi
    </span>
  </div>
);

export default Legend;
